import React from "react";
import { useSelector } from "react-redux";
import { Clock, CircleCheck, FileText } from "lucide-react";
import { Badge } from "antd";

const priorityColor = {
  high: "bg-red-500 dark:bg-red-600 text-white",
  medium: "bg-orange-500 dark:bg-orange-600 text-white",
  low: "bg-yellow-500 dark:bg-yellow-600 text-white",
};

const TasksCard = () => {
  const actionRequiredData = useSelector((state) => state.dashboard.clientActionRequiredSummary.data);
  const tasks = actionRequiredData?.taskList;
  if (!tasks || tasks.length === 0) return null;  

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2">
        <FileText className="w-3.5 h-3.5 text-purple-600 dark:text-purple-500" />
        <h3 className="text-[12px] title-text">Tasks</h3>
        <Badge
          count={tasks.length}          
          size="small"
          style={{
            backgroundColor: "rgb(139 92 246)", 
            color: "#ffffff",
            fontSize: "9px",
          }}
        />
      </div>

      {tasks.map((task, idx) => (
        <div
          key={idx}
          className="bg-card flex flex-col gap-6 rounded-xl mb-2 border border-slate-200"
        >
          <div className="pb-2 pt-3 px-3">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                  <h4 className="text-[13px] title-text">{task.title}</h4>
                  <span
                    className={`inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 text-[9px] px-1.5 py-0 ${priorityColor[task.priority]}`}
                  >
                    {task.priority}
                  </span>
                </div>
                <p className=" muted-text dark:text-zinc-400 text-[11px] line-clamp-2">
                  {task.description}
                </p>
              </div>
            </div>
          </div>

          <div className="pb-2 px-3">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div className="flex items-center gap-2 flex-wrap">
                <div className="flex items-center gap-1 muted-text">
                  <Clock className="w-3 h-3 " />
                  <p className="text-[10px]">{task.dueDate}</p>
                </div>
                <span className="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 text-[9px] px-1.5 py-0 bg-slate-50">
                  {task.department}
                </span>
              </div>

              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-lg gap-1.5 h-6 text-[10px] px-2 bg-purple-600 hover:bg-purple-700 text-white">
                <CircleCheck className="w-3 h-3 mr-1" />
                Complete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TasksCard;
